// @flow

import { createVirtualBackgroundEffect } from '../../stream-effects/virtual-background';

import logger from './logger';

/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promsie} - A Promise which resolves when all effects are created.
 */
export default function loadEffects(store: Object): Promise<any> {
    const state = store.getState();

    const virtualBackground = state['features/virtual-background'];
    // const virtualBackground = Object.keys(virtualBackgroundFromState).length > 0 ? virtualBackgroundFromState : {
    //     "backgroundEffectEnabled": true,
    //     "virtualSource": "../../../../images/virtual-background/background-1.jpg",
    //     "backgroundType": "image",
    //     "selectedThumbnail": "1"
    // }

    const backgroundPromise = virtualBackground.backgroundEffectEnabled
        ? createVirtualBackgroundEffect(virtualBackground)
            .catch(error => {
                logger.error('Failed to obtain the background effect instance with error: ', error);

                return Promise.resolve();
            })
        : Promise.resolve();

    return Promise.all([backgroundPromise]);
}
